import { DataType } from "../../dataType"

export interface InsightPresetParameter {
	id: string
	title: string
	description: string
	helpText?: string
	placeholder?: string
	isRequired: boolean
	isMultiSelect: boolean
	isField: boolean
	dataType: DataType
	options?: { label: string; value: unknown }[]
}

export interface InsightPreset {
	id: string
	title: string
	description: string
	tenantFeatureFlag?: string
	parameters: InsightPresetParameter[]
}

export enum InsightPresetKeys {
	TimeManagementWeeklyReport = "timeManagementWeeklyReport",
}
